"use client";

import React, { useState, useEffect } from "react";
import Image from "next/image";
import { useUser } from "@auth0/nextjs-auth0/client";
import SignUpRequiredModal from "../../../components/modal/signup-required";
import { useRouter } from "next/router";
import ClaimRider from "../../../components/claim-rider/claim-rider";
import { SignupButton } from "../../../components/header/SignupButton";
import NowVurbmotoProspect from "../../../components/now-vurbmoto-prospect-section/now-vurbmoto-prospect-section";
const Index = () => {
  return <>
      <NowVurbmotoProspect />
    </>;
};
export default Index;